function getEditIcon() {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>`;
}

function getTrashIcon() {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>`;
}

let articles = [];
let couleursDisponibles = [];

fetch("https://script.google.com/macros/s/AKfycbw8ZyrSCpXnPff-9JwN6AjfLfvaM-wShLAdlvSJxAhtqbn-qlo79dhHNvRYTL_A6BnsaQ/exec")
  .then(res => res.json())
  .then(data => {
    articles = data.articles;
    couleursDisponibles = data.couleurs;

    const select = document.getElementById("codeArticle");
    select.innerHTML = '<option value="">-- Choisir --</option>' +
      articles.map(a => `<option value="${a.code}">${a.code}</option>`).join('');
  })
  .catch(err => console.error("Erreur de chargement des articles :", err));

let currentEditIndex = null;

function resetSelect(selectId, withStyle = true) {
  const el = document.getElementById(selectId);
  if (!el) return;
  el.innerHTML = '<option value="">-- Choisir --</option>';
  el.disabled = true;
  el.className = "form-input select-none bg-secondary-4";
  if (withStyle) {
    el.style.borderRight = "10px solid transparent";
  } else {
    el.removeAttribute("style");
  }
}

function resetQuantiteInput() {
  const quantite = document.getElementById('quantiteArticle');
  if (!quantite) return;
  quantite.value = 1;
  quantite.disabled = true;
  quantite.className = "form-input bg-secondary-4"
}

function openModal(index = null) {
  currentEditIndex = index;

  if (index !== null) {
    // Mode édition
    const ligne = lignesCommande[index];

    const codeArticlePur = ligne.code.split("-").slice(0,-1).join("-")

    document.getElementById('codeArticle').value = codeArticlePur;
    updateArticleFields(); // Recharge les infos associées à l'article

    // Attendre un petit délai que updateArticleFields ait modifié les selects (async via DOM), puis remplir les champs
    setTimeout(() => {
      document.getElementById('couleurArticle').value = ligne.couleur || "";
      document.getElementById('tailleArticle').value = ligne.taille || "";
      document.getElementById('quantiteArticle').value = ligne.quantite || 1;
    }, 100); // peut être ajusté si nécessaire

  } else {
    // Mode ajout
    document.getElementById('codeArticle').value = "";
    document.getElementById('nomArticle').value = "";
    document.getElementById('categorieArticle').value = "";
    document.getElementById('largeurArticle').value = "";
    document.getElementById('couleurArticle').innerHTML = '<option value="">-- Choix Couleur --</option>';
    document.getElementById('tailleArticle').innerHTML = '<option value="">-- Choix Taille --</option>';
    document.getElementById('quantiteArticle').value = 1;
  }

  document.getElementById('modal').classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  document.getElementById('modal').classList.add('hidden');
  resetSelect('couleurArticle');
  resetSelect('tailleArticle');
  resetQuantiteInput();
  document.body.style.overflow = '';
}

function updateArticleFields() {
  const code = document.getElementById('codeArticle').value;
  const article = articles.find(a => a.code === code);
  if (!article) return;

  document.getElementById('nomArticle').value = article.nom;
  document.getElementById('categorieArticle').value = article.categorie;
  document.getElementById('largeurArticle').value = article.largeur || 'Non Concerné';

  const couleurSelect = document.getElementById('couleurArticle');
  const couleurs = article.couleurs || [];
  
  const tailleSelect = document.getElementById('tailleArticle');
  const tailles = article.tailles || [];
  
  const quantite = document.getElementById('quantiteArticle');
  
  // Activation + injection couleurs
  if (couleurs.length === 0) {
    couleurSelect.disabled = true;
    couleurSelect.className = "form-input select-none bg-secondary-4";
    couleurSelect.style.borderRight = "10px solid transparent";
    couleurSelect.innerHTML = '<option value="">-- Pas de Couleur --</option>'
  } else {    
    couleurSelect.disabled = false;
    couleurSelect.className = "w-full form-select text-secondary-4";
    couleurSelect.style.borderRight = "10px solid transparent";
    couleurSelect.innerHTML = '<option value="">-- Choix Couleur --</option>' + 
      couleurs.map(c => `<option value="${c}">${c}</option>`).join('');
  }
  
  // Gestion taille selon présence ou absence de valeurs
  if (tailles.length === 0) {
    tailleSelect.disabled = true;
    tailleSelect.className = "form-input select-none bg-secondary-4";
    tailleSelect.style.borderRight = "10px solid transparent";
    tailleSelect.innerHTML = '<option value="">-- Pas d’option --</option>';
  } else {
    tailleSelect.disabled = false;
    tailleSelect.className = "w-full form-select text-secondary-4";
    tailleSelect.style.borderRight = "10px solid transparent";
  
    if (code === "HOM-004") {
      tailleSelect.innerHTML = '<option value="">-- Choix Couleur Élastique --</option>' + 
        tailles.map(t => `<option value="${t}">${t}</option>`).join('');
    } else {
      tailleSelect.innerHTML = '<option value="">-- Choix Taille --</option>' + 
        tailles.map(t => `<option value="${t}">${t}</option>`).join('');
    }
  }

  quantite.disabled = false;
  quantite.className = "w-full form-select text-secondary-4";
}

let lignesCommande = [];

function saveLine() {
  const champsRequis = [
    'codeArticle',
    'nomArticle',
    'categorieArticle',
    'largeurArticle',
    'couleurArticle',
    'tailleArticle',
    'quantiteArticle'
  ];

  let erreur = false;

  champsRequis.forEach(id => {
    const champ = document.getElementById(id);
    if (!champ.disabled && !champ.value.trim()) {
      champ.classList.add('erreur-champ');
      erreur = true;
    } else {
      champ.classList.remove('erreur-champ');
    }
  });

  const quantiteChamp = document.getElementById('quantiteArticle');
  if (!quantiteChamp.disabled && parseInt(quantiteChamp.value, 10) <= 0) {
    quantiteChamp.classList.add('erreur-champ');
    erreur = true;
  }

  if (erreur) {
    return;
  }

  // Poursuite de l'enregistrement si tout est OK :

  const codeArticle = document.getElementById('codeArticle').value;
  const nomArticle = document.getElementById('nomArticle').value;
  const couleurNom = document.getElementById('couleurArticle').value;
  const codeTaille = document.getElementById('tailleArticle').value

  const couleurCode = couleursDisponibles.find(c => c.nom === couleurNom)?.code || "";
  
  let codeFinal = codeArticle;

  if (couleurCode) {
    codeFinal += `-${couleurCode}`;
  }

  if (codeTaille) {
    codeFinal += `-${codeTaille}`;
  }

  
  const ligne = {
    code: codeFinal,
    nom: nomArticle,
    categorie: document.getElementById('categorieArticle').value,
    largeur: document.getElementById('largeurArticle').value,
    couleur: couleurNom,
    taille: document.getElementById('tailleArticle').value,
    quantite: document.getElementById('quantiteArticle').value
  };

  if (currentEditIndex !== null) {
    lignesCommande[currentEditIndex] = ligne;
  } else {
    lignesCommande.push(ligne);
  }

  renderTable();
  closeModal();
  resetSelect('couleurArticle');
  resetSelect('tailleArticle');
  resetQuantiteInput();
}

// Version sécurisée de renderTable()
function renderTable() {
  const body = document.getElementById('orderBody');
  body.innerHTML = lignesCommande.map((ligne, index) => `
    <tr>
      <td>${escapeHTML(ligne.code)}</td>
      <td>${escapeHTML(ligne.nom)}</td>
      <td>${escapeHTML(ligne.categorie)}</td>
      <td>${escapeHTML(ligne.largeur)}</td>
      <td>${escapeHTML(ligne.couleur)}</td>
      <td>${escapeHTML(ligne.taille)}</td>
      <td>${escapeHTML(ligne.quantite)}</td>
      <td>
        <button onclick="openModal(${index})" class="icon-button edit" title="Modifier">
          ${getEditIcon()}
        </button>
        <button onclick="deleteLine(${index})" class="icon-button delete" title="Supprimer">
          ${getTrashIcon()}
        </button>
      </td>
    </tr>
  `).join('');
}

function deleteLine(index) {
  lignesCommande.splice(index, 1);
  renderTable();
}

function submitOrder() {
  const status = document.getElementById("form-status");
  const loader = document.getElementById("form-loader");
  const submit = document.getElementById("submit");
  const siren = document.getElementById('siren').value.trim();
  const email = document.getElementById('email').value.trim();
  const clientName = document.getElementById('clientName').value.trim();

  if (!email || !clientName || lignesCommande.length === 0) {
    alert("Veuillez compléter toutes les informations client et ajouter au moins une ligne.");
    return;
  }

  const form = new FormData();
  form.append("siren", siren);
  form.append("clientName", clientName);
  form.append("email", email);
  form.append("lignes", JSON.stringify(lignesCommande));

  // Réinitialise le message et affiche le loader
  status.innerText = "";
  loader.classList.remove("hidden");
  submit.classList.add("hidden");

  fetch("https://script.google.com/macros/s/AKfycbzBTcv0S0s_pSOCXxIKMjX4LZkcHT-kuInTtjC4PUlLXQr2R4aiPYb0YpI9P4uCykC4Dw/exec", {
    method: "POST",
    body: form
  })
    .then(res => res.text())
    .then((text) => {
      loader.classList.add("hidden");
      status.innerText = "{{ 'templates.contactPro.form.statutValid' | t }}";
      form.reset();
      location.reload();
    })
    .catch(err => {
      console.warn("Réponse bloquée par CORS, mais la commande est probablement bien enregistrée.");
      loader.classList.add("hidden");
      status.innerText = "Commande envoyée avec succès !"; // ✅ message positif même si fetch échoue
    });
}

// Fonction pour échapper le HTML
function escapeHTML(str) {
  if (!str) return '';
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}